import type { EFrom } from 'reactApp/components/SharingWindow/Sharing.types';
import type { XrayItemType } from 'reactApp/modules/home/home.types';
import type { PublishItem } from 'reactApp/modules/modifying/modifying.types';

export const enum SHARING_VARIANT {
    default = 'default',
    folders = 'folders',
    files = 'files',
    foldersBiz = 'foldersBiz',
    filesBiz = 'filesBiz',
    albumsBiz = 'albumsBiz',
}

export interface IProps {
    item?: PublishItem;
    from: EFrom;
    isPhone?: boolean;
    isReadOnly: boolean;
    isEmbeded?: boolean;
    variant?: SHARING_VARIANT;
    xrayItemType: XrayItemType;
}
